// DS3.5
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import InputErrorMessage from '@wix/da-ds/pkg/formControls/lego/InputErrorMessage';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import InputLabelSubText from '@wix/da-ds/pkg/formControls/lego/InputLabelSubText';
import FormElement from '@wix/da-ds/pkg/formControls/layouts/FormElement';
import ArrowDown from '@wix/da-ds/pkg/Icons/16x16/ArrowDown';
import ArrowUp from '@wix/da-ds/pkg/Icons/16x16/ArrowUp';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NativeDropdown from '../../NativeDropdown';
import DropdownStateManager, { DropdownStateContext } from '../../DropdownStateManager';
import noop from '../../../utils/noop';
import s from './SelectField.scss';
const SelectField = ({ id, className, label, subLabel, isLabelHidden, isRequired, withBlankOption = true, items, value, error, placeholder: placeholderProp, onSelect = noop, noBottomSpacing = true })=>{
    var _items_find;
    const { t } = useTranslation();
    const selectListId = `${id}-list`;
    const { isOpen, setToggleRef } = useContext(DropdownStateContext);
    const placeholder = placeholderProp !== null && placeholderProp !== void 0 ? placeholderProp : t('common.select');
    const options = useMemo(()=>[
            ...withBlankOption ? [
                {
                    label: placeholder,
                    value: ''
                }
            ] : [],
            ...items.map((item)=>_object_spread_props(_object_spread({}, item), {
                    selected: `${item.value}` === value
                }))
        ], [
        withBlankOption,
        items,
        value,
        placeholder
    ]);
    var _items_find_label;
    const valueLabel = useMemo(()=>(_items_find_label = (_items_find = items.find((item)=>`${item.value}` === value)) === null || _items_find === void 0 ? void 0 : _items_find.label) !== null && _items_find_label !== void 0 ? _items_find_label : placeholder, [
        items,
        value,
        placeholder
    ]);
    const Icon = isOpen ? ArrowUp : ArrowDown;
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], isOpen && s['open'], error && s['error'], className)
    }, /*#__PURE__*/ React.createElement(FormElement, {
        inputId: id,
        label: /*#__PURE__*/ React.createElement(InputLabelText, {
            isRequired: isRequired,
            className: "label"
        }, label),
        subLabel: /*#__PURE__*/ React.createElement(InputLabelSubText, {
            className: "sublabel"
        }, subLabel),
        isLabelHidden: isLabelHidden,
        noBottomSpacing: noBottomSpacing,
        details: error && /*#__PURE__*/ React.createElement(InputErrorMessage, {
            id: `${id}-error`
        }, error)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, /*#__PURE__*/ React.createElement("div", {
        id: id,
        tabIndex: 0,
        className: c(s['input'], 'ignore-react-onclickoutside'),
        ref: setToggleRef,
        role: "menu",
        "aria-controls": selectListId
    }, value && /*#__PURE__*/ React.createElement("div", {
        className: s['value']
    }, valueLabel), !value && placeholder && /*#__PURE__*/ React.createElement("div", {
        className: s['placeholder']
    }, placeholder), /*#__PURE__*/ React.createElement(Icon, {
        className: s['icon'],
        size: IconSize.SMALLER,
        disableDefaultColors: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['native-dropdown-hidden']
    }, /*#__PURE__*/ React.createElement(NativeDropdown, {
        onSelect: onSelect,
        items: options
    })))));
};
SelectField.displayName = 'SelectField';
const SelectFieldWithDropdownState = (props)=>/*#__PURE__*/ React.createElement(DropdownStateManager, null, /*#__PURE__*/ React.createElement(SelectField, props));
export default SelectFieldWithDropdownState;
